// Query keys shared by the board's live queries, by the mutations that
// invalidate them and by the realtime events that do the same.
export const MONITORING_QUERY_KEYS = {
  /** Prefix of every satellite live read (the board and its details). */
  live: ['monitoring', 'live'] as const,
  liveBoard: ['monitoring', 'live', 'board'] as const,
  custodyBoard: ['monitoring', 'custody', 'board'] as const,
  /** Prefix of every custody bitácora read, whichever service it is. */
  custodyBitacoraAll: ['monitoring', 'custody', 'bitacora'] as const,
  custodyBitacora: (id: string) =>
    ['monitoring', 'custody', 'bitacora', id] as const,
  /** Prefix of every satellite bitácora read, whichever service it is. */
  reportsAll: ['monitoring', 'logs'] as const,
  reports: (monitoringId: string) =>
    ['monitoring', 'logs', monitoringId] as const,
};

/**
 * The key every write a board card makes carries, so the board can read which
 * services have one in flight (`useMutationState`) without mistaking any other
 * write in the app for one of its own.
 */
export const BOARD_WRITE_KEY = ['console', 'board-write'] as const;

/**
 * How long a live read stays fresh: until an event or a reconnection says
 * otherwise. These queries are never polled and never refetched on focus; the
 * socket is what tells them they changed (see `useMonitoringRealtime`).
 */
export const LIVE_QUERY_STALE_TIME = Infinity;
